import { assign } from 'lodash';

export class ListHelpers {
    static updateItem<T extends Object>(
        items: Array<T>,
        predicate: (item: T) => boolean,
        newItemFields: Partial<T>
    ): Array<T> {
        return items.map(item => {
            if (!predicate(item)) {
                return item;
            }

            return assign({}, item, newItemFields);
        });
    }
}
